import classname from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import {
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
//i18n
import { withTranslation } from "react-i18next";

import OutsideClickHandler from "react-outside-click-handler";
import { connect } from "react-redux";
import { generateKey } from "../../pages/Common/CommonFunctions/commonFunctions";

const Navbar = (props) => {
  const [showReports, setShowReports] = useState(false);

  var authUser = JSON.parse(localStorage.getItem("authUser"));

  const [menu, setMenu] = useState([]);
  const dropdownContainerRef = useRef(null);

  authUser?.headerMenu?.rightMenus?.sort((a, b) => a.priority - b.priority);

  console.log("Left Menus:", authUser?.headerMenu?.leftMenus);
  console.log("Right Menus:", authUser?.headerMenu?.rightMenus);

  const toggle = (index) => {
    let updatedMenu = menu.map((eachMenu, i) =>
      i === index ? !eachMenu : false,
    );
    setMenu(updatedMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownContainerRef.current &&
        !dropdownContainerRef.current.contains(event.target)
      ) {
        // Click is outside the dropdown, so close it
        setMenu(menu.map(() => false));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menu]);

  useEffect(() => {
    let newMenu =
      authUser?.headerMenu?.leftMenus?.map((eachMenu) => {
        return false;
      }) || [];
    setMenu(newMenu);
  }, []);

  useEffect(() => {
    const pathName = props.location.pathname;
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    var myTeamUrls = ["/myteam/addnewuser", "/myteam/updateuser"];
    var candidateUrls = [
      "/candidate/add",
      "/candidate/:candidateId/edit",
      "/importcandidates",
      "/candidate/:candidateId",
      "/matchcandidate",
    ];
    // Generate the regular expression pattern dynamically
    const candidateUrlsRegexPattern = new RegExp(
      "^(" +
        candidateUrls.map((url) => url.replace(/:\w+/g, "\\w+")).join("|") +
        ")$",
    );

    var jobUrls = [
      "/job/add",
      "/job/:jobId/edit",
      "/importjob",
      "/job/:jobId/process",
      "/match",
      "/job",
      "/job/:jobId/process/candidate/:candidateId",
    ];
    // Generate the regular expression pattern dynamically for job urls
    const jobUrlsRegexPattern = new RegExp(
      "^(" +
        jobUrls.map((url) => url.replace(/:\w+/g, "\\w+")).join("|") +
        ")$",
    );
    var recruiterOrganizationUrls = [
      "/dashboard",
      "/recruiter/viewall",
      "/recruiter/addorganization",
      "/recruiter/editorganization",
      "/recruiter/organization/view",
    ];
    var recruiterJobUrls = [
      "/recruiter/job/addjob",
      "/recruiter/job/updatejob",
      "/recruiter/job/viewall",
      "/recruiter/job/importjob",
      "/recruiter/job/viewJob",
      "/recruiter/job/match",
    ];
    var recruiterCandidateUrls = [
      "/recruiter/candidate/addcandidate",
      "/recruiter/candidate/updatecandidate",
      "/recruiter/candidate/viewall",
      "/recruiter/candidate/bulkimport",
      "/recruiter/candidate/viewcandidate",
      "/recruiter/candidate/matchcandidate",
    ];
    var recruiterInterviews = ["/recruiter/interviews"];
    var adminOrganization = [
      "/admin/addOrganization",
      "/admin/editorganization",
      "/admin/company",
    ];
    var adminReports = [
      "/admin/report/activeClient",
      "/admin/report/newClient",
      "/admin/report/totalJobs",
    ];

    function trimUrl(url) {
      let trimUr = url.split("/");
      if (trimUr.length >= 2) {
        return `/${trimUr[1]}/${trimUr[2]}`;
      }
    }

    for (let i of items) {
      if (props.location.pathname === i.pathname) {
        matchingMenuItem = i;
        break;
      }

      if (matchingMenuItem == null) {
        if (myTeamUrls.includes(props.location.pathname)) {
          for (let it of items) {
            if (it.pathname === "/myteam/viewall") {
              matchingMenuItem = it;
              break;
            }
          }
        } else if (
          candidateUrls.includes(pathName) ||
          candidateUrlsRegexPattern.test(pathName)
        ) {
          for (let ite of items) {
            if (
              ite.pathname === "/candidate" ||
              ite.pathname === "/candidates"
            ) {
              matchingMenuItem = ite;
              break;
            }
          }
        } else if (
          jobUrls.includes(pathName) ||
          jobUrlsRegexPattern.test(pathName)
        ) {
          for (let iter of items) {
            if (iter.pathname === "/job") {
              matchingMenuItem = iter;
              break;
            }
          }
        } else if (recruiterJobUrls.includes(pathName)) {
          for (let itera of items) {
            if (itera.pathname === "/recruiter/job/viewall") {
              matchingMenuItem = itera;
              break;
            }
          }
        } else if (recruiterInterviews.includes(pathName)) {
          for (let iterat of items) {
            if (iterat.pathname === "/recruiter/interviews") {
              matchingMenuItem = iterat;
              break;
            }
          }
        } else if (recruiterCandidateUrls.includes(pathName)) {
          for (let iterati of items) {
            if (iterati.pathname === "/recruiter/candidate/viewall") {
              matchingMenuItem = iterati;
              break;
            }
          }
        } else if (recruiterOrganizationUrls.includes(pathName)) {
          for (let iteratio of items) {
            if (iteratio.pathname === "/recruiter/viewall") {
              matchingMenuItem = iteratio;
              break;
            }
          }
        } else if (
          adminOrganization.includes(pathName) ||
          adminOrganization.includes(trimUrl(pathName))
        ) {
          for (let iteration of items) {
            if (iteration.pathname === "/admin/organization") {
              matchingMenuItem = iteration;
              break;
            }
          }
        } else if (adminReports.includes(pathName)) {
          if (!showReports) {
            setShowReports(true);
          }
        } else {
          setShowReports(false);
        }
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });
  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  const getClassNameNavItem = (name) => {
    if (name === "Candidates") {
      if (props.location.pathname.includes("candidate")) {
        return "nav-item active";
      } else {
        return "nav-item";
      }
    } else {
      return "nav-item";
    }
  };

  const getClassNameNavLink = (name) => {
    if (name === "Candidates") {
      if (
        props.location.pathname.includes("candidate") &&
        !props.location.pathname.includes("job") &&
        !props.location.pathname.includes("report")
      ) {
        return "nav-link active";
      } else {
        return "nav-link";
      }
    }
    // for organization module we are using job and for recruiter we are using jobs need to check why we using
    //different names
    else if (name === "Job" || name === "Jobs") {
      if (
        props.location.pathname.includes("job") &&
        !props.location.pathname.includes("report")
      ) {
        return "nav-link active";
      } else {
        return "nav-link";
      }
    } else {
      return "nav-link";
    }
  };

  const handleOutSide = () => {
    setMenu(menu.map(() => false));
  };
  return (
    <React.Fragment>
      <div className="topnav">
        <nav
          key={generateKey()}
          className="navbar navbar-light navbar-expand-xl topnav-menu active"
          id="navigation"
        >
          <Collapse
            id="topnav-menu-content"
            key={generateKey()}
            isOpen={props.leftMenu}
            className="navbar-collapse"
          >
            <ul className="navbar-nav  active navbar-top">
              {authUser?.headerMenu?.leftMenus?.map((option, index) => (
                <React.Fragment key={generateKey()}>
                  {option.image != null && option.image !== "" ? (
                    <>
                      <Dropdown
                        key={generateKey(index)}
                        isOpen={menu[index]}
                        toggle={(ind) => toggle(ind)}
                        className="d-inline-block"
                      >
                        <DropdownToggle
                          className="btn header-item waves-effect"
                          id="page-header-user-dropdown"
                          tag="button"
                        >
                          <img
                            className="rounded-circle header-profile-user"
                            id={"as-menu-avtar-" + index}
                            src={option.image}
                            alt="Header Avatar"
                          />{" "}
                          <span
                            className="d-none d-xl-inline-block login-person-name text-truncate ms-1"
                            translate="no"
                          >
                            {props.t(option.name)}
                          </span>{" "}
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          {option.subMenus.map((subMenu) => (
                            <DropdownItem key={generateKey()}>
                              <i className={`bx ${subMenu.icon}`}></i>{" "}
                              <Link
                                to={subMenu.url}
                                id={
                                  "as-menu-" +
                                  subMenu?.name
                                    .toLowerCase()
                                    .replaceAll(" ", "-")
                                }
                              >
                                {subMenu.name}
                              </Link>
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </>
                  ) : option?.subMenus?.length > 0 ? (
                    <li
                      key={generateKey()}
                      className={
                        menu[index]
                          ? "nav-item dropdown arrow-none active"
                          : "nav-item dropdown arrow-none"
                      }
                      id={
                        "as-menu-" +
                        option?.name.toLowerCase().replaceAll(" ", "-")
                      }
                    >
                      <Link
                        className={
                          "nav-link dropdown-toggle arrow-none nav-truncate" +
                          (option?.name === "Hiring Process" ||
                          option?.name === "Data Migration"
                            ? " max-width-130"
                            : "")
                        }
                        id={
                          "as-menu-" +
                          option?.name.toLowerCase().replaceAll(" ", "-")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          toggle(index);
                        }}
                        to="Report"
                      >
                        {props.t(option.name)}
                        <div className="arrow-down"></div>
                      </Link>
                      {menu[index] ? (
                        <div
                          className={classname("dropdown-menu", {
                            show: menu[index],
                          })}
                        >
                          <OutsideClickHandler
                            onOutsideClick={(e) => {
                              handleOutSide();
                            }}
                          >
                            {option.subMenus
                              .sort((a, b) => a.priority - b.priority)
                              .map((subMenu) => (
                                <div key={generateKey()}>
                                  {subMenu.urlType == "EXTERNAL" ? (
                                    <a target="_blank" href={subMenu.url}>
                                      {subMenu.name}
                                    </a>
                                  ) : (
                                    <Link
                                      to={subMenu.url}
                                      className={"dropdown-item"}
                                      id={
                                        "as-menu-" +
                                        subMenu?.name
                                          .toLowerCase()
                                          .replaceAll(" ", "-")
                                      }
                                    >
                                      {subMenu.name}
                                    </Link>
                                  )}
                                </div>
                              ))}
                          </OutsideClickHandler>
                        </div>
                      ) : (
                        <></>
                      )}
                    </li>
                  ) : (
                    <li
                      key={generateKey()}
                      className={getClassNameNavItem(option.name)}
                    >
                      <Link
                        to={
                          option.url === "/candidate"
                            ? "/candidates"
                            : option.url
                        }
                        className={
                          getClassNameNavLink(option.name) +
                          " nav-truncate" +
                          (option?.name === "Hiring Process" ||
                          option?.name === "Data Migration"
                            ? " max-width-130"
                            : "")
                        }
                        onClick={props.toggleLeftMenu}
                        id={
                          "as-menu-" +
                          option?.name.toLowerCase().replaceAll(" ", "-")
                        }
                      >
                        <span>{props.t(option.name)}</span>
                      </Link>{" "}
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </Collapse>
        </nav>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar)),
);
